import {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize';
import {getColor, getFontWeight} from '../../styles/utils';

const base = css<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const lettersBase = css<{size: number}>`
  color: ${getColor('text.white')};
  user-select: none;
  font-size: ${p => ms(p.size * 0.375)};
  line-height: ${p => ms(p.size)};
`;

export const lettersWeb = css`
  font-weight: ${getFontWeight('semibold')};
`;

export const lettersNative = css`
  font-family: ${p => p.theme.font.semibold};
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  ${base}
`;

export const native = css<StyledProps>`
  ${base}
`;
